import Component from '@glimmer/component';
import ContactListItemButton from './contact-list-item/item-button.gjs';
import ContactListItemContent from './contact-list-item/item-content.gjs';
import ContactListItemReadOnly from './contact-list-item/item-read-only.gjs';

export default class ContactListItem extends Component {
  get contact() {
    return this.args.contact;
  }

  get userNames() {
    return this.contact?.members?.map(user => user.name).join(' & ') ?? '';
  }

  get isClientContact() {
    return this.contact?.isClient === true;
  }

  get isCoupleContact() {
    return this.contact?.members?.length === 2;
  }

  get isDisabled() {
    return this.contact?.isDisabled === true;
  }

  get isInteractive() {
    return typeof this.args.onSelect === 'function';
  }

  get containerClass() {
    if (this.isInteractive) {
      return ContactListItemButton;
    } else {
      return ContactListItemReadOnly;
    }
  }

  handleClick = () => {
    if (this.args.onSelect) {
      this.args.onSelect(this.contact);
    }
  };

  <template>
    <this.containerClass
      @contact={{@contact}}
      @isDisabled={{this.isDisabled}}
      @onClick={{this.handleClick}}
      @userNames={{this.userNames}}
      inert={{@inert}}
    >
      <ContactListItemContent
        @groupMessagingEnabled={{@groupMessagingEnabled}}
        @isClient={{this.isClientContact}}
        @isCouple={{this.isCoupleContact}}
        @isDisabled={{this.isDisabled}}
        @users={{@contact.members}}
        @userNames={{this.userNames}}
      />
    </this.containerClass>
  </template>
}
